import { EditAnchorComponent } from './../shared/components/edit-anchor/edit-anchor.component';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PreInspectionAppListComponent } from "./pre-inspection-app-list/pre-inspection-app-list.component";
import { PreInspectionDetailComponent } from "./pre-inspection-detail/pre-inspection-detail.component";
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
} from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { ModalModule } from "ngx-bootstrap/modal";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { DataTablesModule } from "angular-datatables";
import { RouterModule } from "@angular/router";
import { BasicModalModule } from "../application/basic-modal/basic-modal.module";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { CreateInspectionComponent } from "./create-inspection/create-inspection.component";
import { InspectionListComponent } from "./inspection-list/inspection-list.component";
import { InspectionDetailComponent } from "./inspection-detail/inspection-detail.component";
import { ChangeStatusComponent } from "./change-status/change-status.component";
import { InspectionFormComponent } from "./inspection-form/inspection-form.component";
import { SharedModule } from "../shared/shared.module";
import { CustomStepComponent } from "../shared/components/custom-step/custom-step.component";
import { CreateAbroadCgmpInspectionComponent } from "./create-abroad-cgmp-inspection/create-abroad-cgmp-inspection.component";
import { RenewAbroadCgmpInspectionComponent } from "./renew-abroad-cgmp-inspection/renew-abroad-cgmp-inspection.component";
import { ErisFormElementsModule } from "eris-forms";
import { UploadListComponent } from "../shared/components/upload-list/upload-list.component";
import { CreateLocalGmpInspectionComponent } from "./create-local-gmp-inspection/create-local-gmp-inspection.component";
import { FormlyFieldConfig, FormlyConfig, FormlyModule } from "@ngx-formly/core";
import { emailValidationMessage, emailValidator } from "./shared/validators/email-validator";
import { normalTextValidator, normalTextValidatorMessage } from "./shared/validators/normal-text-validator";
import { phoneValidationMessage, phoneValidator } from "./shared/validators/phone-validator";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { FileUploadModule } from "ng2-file-upload";
import { NgCircleProgressModule } from "ng-circle-progress";
import { ChecklistsComponent } from '../shared/components/checklists/checklists.component';
import { CheckboxComponent } from "../shared/components/checkbox/checkbox.component";
import { InternationalPhoneComponent } from "../shared/components/international-phone/international-phone.component";
import { legacyFacilityValidationMessage, legacyFacilityValidator } from "./shared/validators/legacy-facility-validator";
import { LegacyDataCapaComponent } from './legacy-data-capa/legacy-data-capa.component';
import { AgmCoreModule } from '@agm/core';
import { GmpProductDetailComponent } from '../shared/components/gmp-product-detail/gmp-product-detail.component';
import { InspectionDetailReadonlyComponent } from './inspection-detail-readonly/inspection-detail-readonly.component';

@NgModule({
  declarations: [
    PreInspectionAppListComponent,
    PreInspectionDetailComponent,
    CreateInspectionComponent,
    InspectionListComponent,
    InspectionDetailComponent,
    ChangeStatusComponent,
    InspectionFormComponent,
    CreateAbroadCgmpInspectionComponent,
    RenewAbroadCgmpInspectionComponent,
    CreateLocalGmpInspectionComponent,
    LegacyDataCapaComponent,
    InspectionDetailReadonlyComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ModalModule,
    BsDatepickerModule,
    DataTablesModule,
    RouterModule,
    BasicModalModule,
    BsDropdownModule,
    ReactiveFormsModule,
    ErisFormElementsModule.forRoot({
      types: [
        { name: "draft-steps", component: CustomStepComponent, wrappers: ['form-field'] }
      ]
    }),
    ButtonsModule,
    SharedModule,
    FormlyModule.forRoot(),
    AccordionModule.forRoot(),
    FileUploadModule,
    NgCircleProgressModule,
    AgmCoreModule
  ],
  exports: [
    InspectionFormComponent
  ],
  entryComponents: [ChangeStatusComponent],
})
export class InspectionModule {
  constructor(formlyConfig: FormlyConfig) {
    formlyConfig.setType({
      name: 'draft-steps',
      component: CustomStepComponent,
      wrappers: ['form-field']
    });
  }
}
